import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, CheckCircleIcon, ZapIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-24 pb-8 md:pt-32 md:pb-16 px-4 bg-white text-center" data-id="element-151">
      <div className="max-w-4xl mx-auto" data-id="element-152">
        <h1 className="text-3xl md:text-5xl font-black text-brand-dark mb-6 leading-tight tracking-tight" data-id="element-153">
          Arrancá el 2026 con todo el material listo
        </h1>

        <div className="mb-8 mx-auto max-w-2xl rounded-2xl overflow-hidden shadow-2xl bg-gradient-to-br from-[#2a2a3a] via-[#3a3a4a] to-[#8b5e34]" data-id="element-154">
          <a href="https://checkout.guiadigital360.online/cart/44005388255301:1" className="block cursor-pointer transform hover:scale-[1.01] transition-transform duration-300" data-id="element-155">
            <img src="https://cdn.magicpatterns.com/uploads/dhbXXAf4wHFATGLH9eN3dQ/PROMPT_ES_Disea_una_portada_ti_Nano_Banana_2_39728.jpg" alt="Mega Pack Desarrollo Infantil 360" className="w-full" data-id="element-156" />
          </a>
        </div>

        <h2 className="text-xl md:text-3xl font-bold text-brand-blue mb-4" data-id="element-157">
          +1000 actividades sin pantalla, organizadas por edad, habilidad y
          necesidad
        </h2>

        <p className="text-lg md:text-xl text-gray-600 font-medium mb-6" data-id="element-158">
          Para chicos de 2 a 10 años · PDF imprimible · Acceso inmediato
        </p>

        <div className="flex flex-wrap justify-center gap-2 mb-8" data-id="element-159">
          {['Lenguaje', 'Atención', 'Motricidad', 'Emociones', 'TEA', 'TDAH', 'Dislexia'].map(tag => <span key={tag} className="bg-brand-light text-brand-blue font-bold px-3 py-1 rounded-full text-sm border border-brand-blue/20" data-id="element-160">
              {tag}
            </span>)}
        </div>

        <div className="max-w-2xl mx-auto text-left bg-gray-50 p-6 rounded-2xl mb-8 border border-gray-100" data-id="element-161">
          <ul className="space-y-4" data-id="element-162">
            {['Listo para usar hoy (PDF imprimible)', 'Rutinas visuales + pictogramas + emociones', 'Material organizado: no tenés que buscar, solo elegir e imprimir', 'Ideal para casa, aula o consultorio'].map((item, i) => <li key={i} className="flex items-start gap-3 text-lg font-medium text-gray-800" data-id="element-163">
                <CheckCircleIcon className="w-6 h-6 text-brand-green flex-shrink-0 mt-0.5" data-id="element-164" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="max-w-2xl mx-auto mb-6" data-id="element-165">
          <CTAButton text="SÍ, QUIERO EL PACK 2026 →" href="https://checkout.guiadigital360.online/cart/44005388255301:1" isLink={true} data-id="element-166" />
        </div>

        <div className="flex flex-wrap justify-center items-center gap-6 text-sm md:text-base text-gray-600 font-medium" data-id="element-167">
          <span className="flex items-center gap-1" data-id="element-168">
            <LockIcon className="w-5 h-5 text-gray-500" data-id="element-169" /> Compra segura con
            Mercado Pago
          </span>
          <span className="flex items-center gap-1" data-id="element-170">
            <ZapIcon className="w-5 h-5 text-yellow-500" data-id="element-171" /> Acceso inmediato
          </span>
          <span className="flex items-center gap-1" data-id="element-172">
            <ShieldCheckIcon className="w-5 h-5 text-brand-green" data-id="element-173" /> Garantía 7
            días
          </span>
        </div>
      </div>
    </section>;
}